import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	genericEmptyStateHeading: {
		id: 'project-picker.empty-state.generic-heading',
		defaultMessage: 'Get started with projects',
		description:
			'Heading displayed on picker empty state when there are no projects available or projects are not turned on',
	},
	createProjectButtonLabel: {
		id: 'project-picker.empty-state.create-project-button-label',
		defaultMessage: 'Create project',
		description: 'Label for button to create a new project',
	},
});
